<template>
  <div>
    <v-btn
      color="primary"
      dark
      class="mb-2"
      @click="dialog = true"
    >
      Novo
    </v-btn>

    <SysDialog
      v-model="dialog"
      :titulo="(VALIDAR_EDITAR ? 'Editar' : 'Cadastro de Nova') + ' Filial'"
      @click:primary="verificarSalvarEditar()"
      @click:hidden-dialog="fecharDialog()"
      :largura="900"
    >

      <div class="row my-0">
        <div class="py-0" :class="!VALIDAR_EDITAR ? 'col-3' : ''">
          <v-text-field
            v-if="!VALIDAR_EDITAR"
            v-model="item.idfilial"
            label="ID Filial*"
            color="#042333"
            outlined
            type="number"
            :error-messages="idFilialErrors"
            @input="$v.item.idfilial.$touch()"
            @blur="$v.item.idfilial.$touch()"
          />
        </div>

        <div class="py-0" :class="!VALIDAR_EDITAR ? 'col-5' : 'col-6'">
          <v-text-field
            v-model="item.cnpj"
            label="CNPJ*"
            color="#042333"
            outlined
            type="number"
            :error-messages="cnpjErrors"
            @input="$v.item.cnpj.$touch()"
            @blur="$v.item.cnpj.$touch()"
          />
        </div>

        <div class="py-0" :class="!VALIDAR_EDITAR ? 'col-4' : 'col-6'">
          <v-text-field
            v-model="item.cep"
            label="CEP*"
            color="#042333"
            outlined
            type="number"
            :error-messages="cepErrors"
            @input="$v.item.cep.$touch()"
            @blur="$v.item.cep.$touch()"
          />
        </div>
      </div>

      <v-text-field
        v-model="item.razao_social"
        label="Razao Social*"
        color="#042333"
        autofocus
        outlined
        :error-messages="razaoSocialErrors"
        @input="$v.item.razao_social.$touch()"
        @blur="$v.item.razao_social.$touch()"
      />

      <v-text-field
        v-model="item.nome_fantasia"
        label="Nome Fantasia*"
        color="#042333"
        outlined
        :error-messages="nomeFantasiaErrors"
        @input="$v.item.nome_fantasia.$touch()"
        @blur="$v.item.nome_fantasia.$touch()"
      />

      <v-text-field
        v-model="item.endereco"
        label="Endereço*"
        color="#042333"
        outlined
        :error-messages="enderecoErrors"
        @input="$v.item.endereco.$touch()"
        @blur="$v.item.endereco.$touch()"
      />

      <div class="row">
        <div class="col">
          <v-text-field
            v-model="item.cidade"
            label="Cidade*"
            color="#042333"
            outlined
            :error-messages="cidadeErrors"
            @input="$v.item.cidade.$touch()"
            @blur="$v.item.cidade.$touch()"
          />
        </div>

        <div class="col">
          <v-text-field
            v-model="item.estado"
            label="Estado*"
            color="#042333"
            outlined
            :error-messages="estadoErrors"
            @input="$v.item.estado.$touch()"
            @blur="$v.item.estado.$touch()"
          />
        </div>
      </div>

      <div class="row mt-0 mb-n4">
        <div class="col py-0">
          <v-text-field
            v-model="item.inscricao_estadual"
            label="Inscrição Estadual"
            color="#042333"
            outlined
          />
          <v-text-field
            v-model="item.suframa"
            label="Suframa"
            color="#042333"
            outlined
          />
        </div>

        <div class="col py-0">
          <v-checkbox v-model="item.status_compra" label="Status Compra" />
          <v-checkbox v-model="item.status_venda" label="Status Venda" />
          <v-checkbox v-model="item.status_distribui" label="Status Distribui" />
          <v-checkbox v-model="item.status_distribuicao" label="Status Distribuição" />
        </div>
      </div>

    </SysDialog>
  </div>
</template>

<script>
import SysDialog from '@/components/padraoDeLayout/SysDialog.vue';
import { required, integer, maxLength } from "vuelidate/lib/validators";
import { salvarFiliaisParametrizacao, editarFiliaisParametrizacao } from "../Api";

export default {
  components: { SysDialog },
  props: {
    editar_item: {
      type: Object
    }
  },
  data: () => ({
    dialog: false,
    item: {
      idfilial: '',
      razao_social: '',
      nome_fantasia: '',
      endereco: '',
      cidade: '',
      estado: '',
      inscricao_estadual: '',
      cnpj: '',
      cep: '',
      suframa: '',
      status_compra: '',
      status_venda: '',
      status_distribui: '',
      status_distribuicao: ''
    }
  }),
  validations: {
    item: {
      idfilial: { required, integer },
      razao_social: { required },
      nome_fantasia: { required },
      endereco: { required },
      cidade: { required },
      estado: { required, maxLength: maxLength(14) },
      cnpj: { required, integer, maxLength: maxLength(14) },
      cep: { required, integer, maxLength: maxLength(8) }
    }
  },
  computed: {
    idFilialErrors() {
      const errors = [];
      if (!this.$v.item.idfilial.$dirty) return errors;
      !this.$v.item.idfilial.required && errors.push("Campo Obrigatório.");
      return errors;
    },
    razaoSocialErrors() {
      const errors = [];
      if (!this.$v.item.razao_social.$dirty) return errors;
      !this.$v.item.razao_social.required && errors.push("Campo Obrigatório.");
      return errors;
    },
    nomeFantasiaErrors() {
      const errors = [];
      if (!this.$v.item.nome_fantasia.$dirty) return errors;
      !this.$v.item.nome_fantasia.required && errors.push("Campo Obrigatório.");
      return errors;
    },
    enderecoErrors() {
      const errors = [];
      if (!this.$v.item.endereco.$dirty) return errors;
      !this.$v.item.endereco.required && errors.push("Campo Obrigatório.");
      return errors;
    },
    cidadeErrors() {
      const errors = [];
      if (!this.$v.item.cidade.$dirty) return errors;
      !this.$v.item.cidade.required && errors.push("Campo Obrigatório.");
      return errors;
    },
    estadoErrors() {
      const errors = [];
      if (!this.$v.item.estado.$dirty) return errors;
      !this.$v.item.estado.required && errors.push("Campo Obrigatório.");
      !this.$v.item.estado.maxLength && errors.push("O campo fornecedor deve conter até 2 caracteres.");
      return errors;
    },
    cnpjErrors() {
      const errors = [];
      if (!this.$v.item.cnpj.$dirty) return errors;
      !this.$v.item.cnpj.required && errors.push("Campo Obrigatório.");
      !this.$v.item.cnpj.maxLength && errors.push("O campo fornecedor deve conter até 14 caracteres.");
      return errors;
    },
    cepErrors() {
      const errors = [];
      if (!this.$v.item.cep.$dirty) return errors;
      !this.$v.item.cep.required && errors.push("Campo Obrigatório.");
      !this.$v.item.cep.maxLength && errors.push("O campo fornecedor deve conter até 8 caracteres.");
      return errors;
    },
    VALIDAR_EDITAR() {
      return Object.keys(this.editar_item).length > 0;
    }
  },
  watch: {
    editar_item(valor) {
      if (this.VALIDAR_EDITAR) {
        this.abrirDialog();
        this.item = valor;
      }
    }
  },
  methods: {
    abrirDialog() {
      this.dialog = true;
    },
    fecharDialog() {
      this.$v.$reset();
      this.$emit('limpar-editar', {});
      this.dialog = false;
      this.item = {
        idfilial: '',
        razao_social: '',
        nome_fantasia: '',
        endereco: '',
        cidade: '',
        estado: '',
        inscricao_estadual: '',
        cnpj: '',
        cep: '',
        suframa: '',
        status_compra: '',
        status_venda: '',
        status_distribui: '',
        status_distribuicao: ''
      }
    },
    verificarSalvarEditar() {
      if (this.VALIDAR_EDITAR) {
        this.editar();
      } else {
        this.salvar();
      }
    },
    editar() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.$store.dispatch(
          'loading/addRequisicao',
          editarFiliaisParametrizacao(this.item)
            .then(() => this.fecharDialog())
            .catch(() => this.Helpers.logout())
        );
      }
    },
    salvar() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.$store.dispatch(
          'loading/addRequisicao',
          salvarFiliaisParametrizacao(this.item)
            .then(() => this.fecharDialog())
            .catch(() => this.Helpers.logout())
        );
      }
    }
  }
}
</script>
